    var Utils = {
        months() {
            const months = {
                full: [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
            };
            return months;
        },
        formatNumber( num ) {
            num = parseFloat( num );
            num = num ? ( num.toFixed(2).replace('.00', '').replace(/\B(?=(\d{3})+(?!\d))/g, ",") ) : 0;
            return num;
        },
        numberToWords() {
            return [ 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten' ];
        },
        setPlural( txt, num ) {
            let result = 0;
            num    = parseInt( num );
            result = txt + ( ! num || num > 1 ? 's' : '' );
            return result;
        },
        getPercentage( part, whole, formatted = true ) {
            let result = 0;
            part  = parseFloat( part );
            whole = parseFloat( whole );
            result = ( part / whole ) * 100;
            result = formatted ? ( result + '%' ) : result;
            return result;
        },
        formatFullMonthDate( date ) {
            let d = new Date( date );
            d = d.getDate() + ' ' + this.months().full[ d.getMonth() ] + ' ' + d.getFullYear();
            return d;
        },
        inRange( n, min, max ) {
            return ( ( n - min ) * ( n - max ) <= 0 );
        },
        validateForm( form ) {
            let valid = true;
            $.each( form.find( 'input[required]:not(.optional)' ), function(index, item) {          
                const field = $(this).closest( '.input' );
                let val = $.trim( $(this).val() );
                let message = '';
                if ( ! val ) {
                    this.focus();
                    valid = false;
                    return false;
                }
                const validate = $(this).attr( 'data-validate' );
                switch( validate ) {
                  case 'email':
                    if ( ! (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(val)) ) {
                        this.focus();
                        message = 'Invalid email address.';                    
                        valid = false;
                    }                 
                  break;
                  case 'password':
                      const pattern = {
                          charLength: function() {
                              if( val.length >= 8 ) {
                                  return true;
                              }
                          },
                          lowercase: function() {
                              var regex = /^(?=.*[a-z]).+$/;
                              if( regex.test(val) ) {
                                  return true;
                              }
                          },
                          uppercase: function() {
                              var regex = /^(?=.*[A-Z]).+$/;
                              if( regex.test(val) ) {
                                  return true;
                              }
                          },
                          special: function() {
                              var regex = /^(?=.*[0-9_\W]).+$/;
                              if( regex.test(val) ) {
                                  return true;
                              }
                          }
                      };
                      if ( ! ( pattern.charLength() && pattern.lowercase() && pattern.uppercase() && pattern.special() ) ) {
                          message = 'Password must be at least 8 characters, contain at least one numeric digit and a special character.';
                          valid = false;
                      }                
                      if ( valid && $(this).attr( 'data-password-ref' ) ) {
                          const $password = form.find( 'input[name="' + $(this).attr( 'data-password-ref' ) + '"]' );
                          if ( $password.val() != val ) {
                              message = "Password mismatched.";
                              valid = false;
                          }
                      }
                  break;
                }
                if ( ! valid ) {
                  if ( message && form.find( '.modal' ).length > 0 ) {
                      form.find( '.modal .content .scroll' ).html( '<p>' + message + '<p>' );
                      form.find( '.modal' ).addClass( 'delay active' );
                  }
                  return false;
                }
            });
            return valid;
        },
        numberWithCommas(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        capitalizeWords(str) {
            return str.replace(/\b\w/g, function (match) {
                return match.toUpperCase();
            });
        },
        htmlDecoder(input){
            let e = document.createElement('textarea');
            e.innerHTML = input;
            return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
        },
        htmlEntities(str) {
            return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        },
        isEnglish(str) {  
            return /^[A-Za-z0-9\s.,!?'"()\-:;â€™â€œâ€â€“â€”â€˜â€¦â€¢â„¢â€â€¡Â©Â®â‚¬Â£Â¥Â§Â±Â¶Â§Â¢Â°Â¹Â²Â³Â¼Â½Â¾Ã€Ã�Ã‚ÃƒÃ„Ã…Ã†Ã‡ÃˆÃ‰ÃŠÃ‹ÃŒÃ�ÃŽÃ�Ã�Ã’Ã“Ã”Ã•Ã–Ã—Ã˜Ã™ÃšÃ›ÃœÃ�ÃžÃŸÃ Ã¡Ã¢Ã£Ã¤Ã¥Ã¦Ã§Ã¨Ã©ÃªÃ«Ã¬Ã­Ã®Ã¯Ã°Ã±Ã²Ã³Ã´ÃµÃ¶Ã·Ã¸Ã¹ÃºÃ»Ã¼Ã½Ã¾Ã¿]+$/.test(str);
        },
        fixEncodingErrors(text) {
            const replacements = {
                "â€™": "’", // right single quotation mark
                "â€œ": "“", // left double quotation mark
                "â€": "”", // right double quotation mark
                "â€“": "–", // en dash
                "â€”": "—", // em dash
                "â€˜": "‘", // left single quotation mark
                "â€¦": "…", // ellipsis
                "â€": "”", // double quotation mark
                "â€¢": "•", // bullet
                "â„¢": "™", // trademark sign
                "â€": "‡", // dagger
                "â€¡": "†", // double dagger
                "Â©": "©", // copyright sign
                "Â®": "®", // registered trademark sign
                "â‚¬": "€", // euro sign
                "Â£": "£", // pound sign
                "Â¥": "¥", // yen sign
                "Â§": "§", // section sign
                "Â±": "±", // plus-minus sign
                "Â¶": "¶", // pilcrow sign
                "Â§": "§", // section sign
                "Â¢": "¢", // cent sign
                "Â°": "°", // degree sign
                "Â¹": "¹", // superscript one
                "Â²": "²", // superscript two
                "Â³": "³", // superscript three
                "Â¼": "¼", // one quarter
                "Â½": "½", // one half
                "Â¾": "¾", // three quarters
                "Ã€": "À", // A with grave accent
                "Ã�": "Á", // A with acute accent
                "Ã‚": "Â", // A with circumflex
                "Ãƒ": "Ã", // A with tilde
                "Ã„": "Ä", // A with diaeresis
                "Ã…": "Å", // A with ring above
                "Ã†": "Æ", // AE
                "Ã‡": "Ç", // C with cedilla
                "Ãˆ": "È", // E with grave accent
                "Ã‰": "É", // E with acute accent
                "ÃŠ": "Ê", // E with circumflex
                "Ã‹": "Ë", // E with diaeresis
                "ÃŒ": "Ì", // I with grave accent
                "Ã�": "Í", // I with acute accent
                "ÃŽ": "Î", // I with circumflex
                "Ã�": "Ï", // I with diaeresis
                "Ã�": "Ñ", // N with tilde
                "Ã’": "Ò", // O with grave accent
                "Ã“": "Ó", // O with acute accent
                "Ã”": "Ô", // O with circumflex
                "Ã•": "Õ", // O with tilde
                "Ã–": "Ö", // O with diaeresis
                "Ã—": "×", // multiplication sign
                "Ã˜": "Ø", // O with stroke
                "Ã™": "Ù", // U with grave accent
                "Ãš": "Ú", // U with acute accent
                "Ã›": "Û", // U with circumflex
                "Ãœ": "Ü", // U with diaeresis
                "Ã�": "Ý", // Y with acute accent
                "Ãž": "Þ", // Thorn
                "ÃŸ": "ß", // sharp s
                "Ã ": "à", // a with grave accent
                "Ã¡": "á", // a with acute accent
                "Ã¢": "â", // a with circumflex
                "Ã£": "ã", // a with tilde
                "Ã¤": "ä", // a with diaeresis
                "Ã¥": "å", // a with ring above
                "Ã¦": "æ", // ae
                "Ã§": "ç", // c with cedilla
                "Ã¨": "è", // e with grave accent
                "Ã©": "é", // e with acute accent
                "Ãª": "ê", // e with circumflex
                "Ã«": "ë", // e with diaeresis
                "Ã¬": "ì", // i with grave accent
                "Ã­": "í", // i with acute accent
                "Ã®": "î", // i with circumflex
                "Ã¯": "ï", // i with diaeresis
                "Ã°": "ð", // eth
                "Ã±": "ñ", // n with tilde
                "Ã²": "ò", // o with grave accent
                "Ã³": "ó", // o with acute accent
                "Ã´": "ô", // o with circumflex
                "Ãµ": "õ", // o with tilde
                "Ã¶": "ö", // o with diaeresis
                "Ã·": "÷", // division sign
                "Ã¸": "ø", // o with stroke
                "Ã¹": "ù", // u with grave accent
                "Ãº": "ú", // u with acute accent
                "Ã»": "û", // u with circumflex
                "Ã¼": "ü", // u with diaeresis
                "Ã½": "ý", // y with acute accent
                "Ã¾": "þ", // thorn
                "Ã¿": "ÿ"  // y with diaeresis
                // Add more replacements as needed
            };
        
            for (const [wrongChar, correctChar] of Object.entries(replacements)) {
                text = text.replace(new RegExp(wrongChar, 'g'), correctChar);
            }
        
            return text;
        },
        buildStar(star, average) {
            let str = 'icons8-star';
            switch (star) {
                case 1:
                    if ( this.inRange( average, 0.25, 0.74 ) ) {
                        str += '-half-empty';
                    }
                    if ( average >= 0.75 ) {
                        str += '-2';
                    }
                    break;
                case 2:
                    if ( this.inRange( average, 1.25, 1.74 ) ) {
                        str += '-half-empty';
                    }
                    if ( average >= 1.75 ) {
                        str += '-2';
                    }
                    break;
                case 3:
                    if ( this.inRange( average, 2.25, 2.74 ) ) {
                        str += '-half-empty';
                    }
                    if ( average >= 2.75 ) {
                        str += '-2';
                    }
                    break;
                case 4:
                    if ( this.inRange( average, 3.25, 3.74 ) ) {
                        str += '-half-empty';
                    }
                    if ( average >= 3.75 ) {
                        str += '-2';
                    }
                    break;
                case 5:
                    if ( this.inRange( average, 4.25, 4.74 ) ) {
                        str += '-half-empty';
                    }
                    if ( average >= 4.75 ) {
                        str += '-2';
                    }
                    break;
                }
            return str;
        },
        generateProductReviews( container ) {
            const _this = this;
            const $container = $(document).find( container );
          
            let product_types = [];
            $container.find( '[data-product_type]' ).each(function() {
                const product_type = $(this).data( 'reviews' ) ? $(this).data( 'reviews' ) : $(this).data( 'product_type' );
                if ( ! product_types.includes( product_type ) ) {
                    product_types.push( product_type );
                }
            });
            for (const product_type of product_types) {
                const productId = encodeURIComponent(product_type);
                const url = `https://alt.hemway.com/api/index.php/review/summary?productId=${productId}`;
                
                const payload = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                };

                fetch(url, payload)
                .then(async (response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    try {
                        const ratings = await response.json();
                        if ( parseFloat( ratings.average ) > 4 ) {
                            let $el = $container.find( '[data-reviews="' + product_type + '"] .rating' );
                            if ( $el.length === 0 ) {
                                $el = $container.find( '[data-product_type="' + product_type + '"] .rating' );
                            }
                            $el.html(
                                `<div class="icon"><i class="icons8 icons8-star-2"></i></div>
                                <div class="text">${ratings.average}</div>`
                            );
                            $el.parent().removeClass( 'hidden' );
                        }
                    } catch (error) {
                        console.log('Failed to parse JSON:', error);
                        return null;
                    }
                })
                .catch((error) => {
                    console.error('Fetch error:', error);
                });
            }
        },
        generateProductsSlider( container, swiper_breakpoints, slider = null ) {
            const _this = this;
            const $slider = $(document).find( container + ( slider ? '[data-slider="' + slider + '"]' : '' ) );
            let items = [];
            let products = [];
            let product_types = [];
        
            $slider.find('.slides .slide').each(function () {
                var item = {
                    featured_image: $(this).data('featured_image'),
                    product_id: $(this).data('product_id'),
                    id: $(this).data('id'),
                    available: $(this).data('available'),
                    price_formatted: $(this).data('price_formatted'),
                    reviews: $(this).data('reviews')
                };
        
                products.push(item);
            });
        
            products.forEach(product => {
                let product_id = product.product_id;
                if (product_id && !items.includes(product_id)) {
                    items.push(product_id);
                }
            });
        
            const queryString = items
                .map(item => `id:${item}`)
                .join(' OR ');
            const template = 'products';
            const url = `${window.routes.searchUrl}?view=${template}&q=${queryString}`;
        
            fetch(url, {
                credentials: 'same-origin',
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(response => {
                let $content = '';
                products.forEach(product => {
                    const dataIndex = response.findIndex(item => product.product_id === item.id);
                    if (dataIndex === -1) {
                        console.warn('Product not found in response:', product);
                        return;
                    }
                    const data = response[dataIndex];
                    const url = data.url.includes('?') ? `${data.url}&variant=${product.id}` : `${data.url}?variant=${product.id}`;
    
                    if (!product_types.includes(data.type)) {
                        product_types.push(data.type);
                    }

                    let reviewTag = data.tags.find(tag => tag.startsWith('Reviews_'));
                    reviewTag = reviewTag ? reviewTag.replace('Reviews_', '') : data.type;
    
                    $content += `
                        <div class="slide" data-product_type="${data.type}" data-reviews="${reviewTag}">
                            <div class="product">
                                <a href="${url}">
                                    <div class="images">
                                        <div class="image one" style="background-image: url('${product.featured_image}');"></div>
                                    </div>
                                    <div class="title">
                                        <h3 class="three">${data.title}</h3>
                                    </div>
                                </a>
                                <div class="content">
                                    <div class="blocks one">
                                        <div class="block">
                                            <div class="attributes">
                                                <div class="attribute color">
                                                    <div class="icon">
                                                        <span>•</span><span>•</span><span>•</span>
                                                    </div>
                                                    <div class="text">${data.colour}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="blocks two">
                                        <div class="block">
                                            <div class="price">
                                                <div class="text">${product.price_formatted}</div>
                                            </div>
                                        </div>
                                        <div class="block hidden">
                                            <div class="rating"></div>
                                        </div>
                                    </div>
                                    <div class="blocks three">
                                        <div class="block">
                                            <div class="button small ${(product.available ? 'add-to-bag' : 'sold-out')}" data-product_id="${product.id}" data-quantity="1">
                                                <div class="action">
                                                    <div class="text">${product.available ? 'Add To Bag' : 'Sold Out'}</div>
                                                    <div class="background"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`;
                });
    
                $slider.find('.slides').html($content);
            })
            .then(() => {
                  var swiperSlider = new Swiper($slider[0], {
                      containerModifierClass: 'slide-',
                      noSwipingClass: 'alt',
                      slideActiveClass: 'active',
                      slideBlankClass: 'blank',
                      slideClass: 'slide',
                      slideNextClass: 'next',
                      slidePrevClass: 'previous',
                      slideVisibleClass: 'visible',
                      wrapperClass: 'slides',
                      speed: 750,
                      centerInsufficientSlides: true,
                      navigation: {
                          disabledClass: 'disabled',
                          nextEl: $slider.find( '.buttons .next' )[0],
                          prevEl: $slider.find( '.buttons .previous' )[0]
                      },
                      breakpoints: swiper_breakpoints
                  });
                  $slider.removeClass('hidden');
                  $slider.closest( '.hidden' ).removeClass( 'hidden' );
                _this.generateProductReviews($slider);
            })
            .catch(error => {
                console.error('Fetch error:', error);
            });
        },
        showNavigation() {
            const scrollTop   = $(window).scrollTop();
            const $container  = $( '.overview .content .blocks .tabs' );
            const $navigation = $( '.navigation' );
            if ( scrollTop >= $container.offset().top ) {
                $navigation.addClass( 'active' )
            } else {
                $navigation.removeClass( 'active' )
            }
        },
        setCookie(name, value) {
            var date = new Date();
            date.setMonth(date.getMonth() + 6);
            document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + date.toUTCString() + "; path=/";
        },
        hyphenate(str) {
            if (!str) return '';
            return str
                .toString()
                .trim()
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/^-+|-+$/g, '');
        },
    };
